import { useTheme } from '@/app/ThemeContext';

export const LoginHero = () => {
  const { currentTheme } = useTheme();

  return (
    <div
      data-theme={currentTheme}
      className="relative flex basis-0 flex-col justify-center overflow-hidden max-md:hidden md:basis-1/2 xl:basis-3/5"
    >
      <div className="bg-chariot-background-primary h-full w-full">
        <img
          src="/icons/praetorian-guards.png"
          alt="Praetorian Guards"
          className="absolute top-1/2 left-1/2 h-auto w-[600px] -translate-x-1/2 -translate-y-1/2 opacity-50"
        />
        <div className="relative z-10 flex size-full flex-col items-center justify-center" />
      </div>
    </div>
  );
};
